export const ROLE_TYPE = {
  SYSTEM_ADMIN: 'SYSTEM_ADMIN',
  COMPANY_ADMIN: 'COMPANY_ADMIN',
  PORTFOLIO_ADMIN: 'PORTFOLIO_ADMIN',
  EDITOR: 'EDITOR',
  USER: 'USER',
  CANCELED: 'CANCELED',
  UNPAID: 'UNPAID'
}

export const PERMISSION_TYPE = {
  SEE_ALL_SCREEN: 'SEE_ALL_SCREEN',
  MANAGEMENT_USER: 'MANAGEMENT_USER',
  MANAGEMENT_PORTFOLIO: 'MANAGEMENT_PORTFOLIO',
  MANAGEMENT_PORTFOLIO_MEMBER: 'MANAGEMENT_PORTFOLIO_MEMBER',
  EDIT: 'EDIT',
  VIEW: 'VIEW'
}

export const PLAN_TYPE = {
  ENTERPRISE: 'ENTERPRISE',
  BASIC: 'BASIC',
  TEAM: 'TEAM'
}
